module.exports = __webpack_public_path__ + "img/gjng2900_1.d30f58f1.svg";